<div class="struktur-editor" [class.struktur-editor-gesperrt]="disabled">

  <!-- Kopfzeile der Spaltentabelle -->
  <div class="editor-kopf" *ngIf="spalten.length > 0">
    <span class="kopf-griff"></span>
    <span class="kopf-name">Spaltenname</span>
    <span class="kopf-typ">Datentyp</span>
    <span class="kopf-pflicht">Pflicht</span>
    <span class="kopf-kennz" matTooltip="Genau eine Spalte benennt die Messstelle bzw. den Verbraucher fachlich – z. B. KKS, AKZ oder eine Gerätenummer. Sie ist immer Pflicht und je Liste eindeutig.">
      Kennzeichnung
    </span>
    <span class="kopf-aktionen"></span>
  </div>

  <!-- Spalten: ziehen zum Sortieren, Pfeile als Alternative -->
  <div class="editor-zeilen" cdkDropList (cdkDropListDropped)="abgelegt($event)" [cdkDropListDisabled]="disabled">

    <div class="editor-zeile" *ngFor="let spalte of spalten; let i = index; trackBy: trackByKey" cdkDrag
      [cdkDragDisabled]="disabled" [class.editor-zeile-kennz]="spalte.istKennzeichnung"
      [class.editor-zeile-fehler]="zeilenFehler(spalte)">

      <span class="zeile-griff" cdkDragHandle [attr.aria-label]="'Spalte ' + (spalte.name || i + 1) + ' verschieben'">
        <mat-icon>drag_indicator</mat-icon>
      </span>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="zeile-name">
        <mat-label>Spaltenname</mat-label>
        <input matInput [(ngModel)]="spalte.name" (ngModelChange)="geaendert()" [disabled]="disabled" maxlength="120"
          [placeholder]="spalte.istKennzeichnung ? 'z. B. KKS, AKZ, Gerätenummer' : 'z. B. Langtext'">
        <mat-hint *ngIf="zeilenFehler(spalte)" class="zeile-hinweis-fehler">{{ zeilenFehler(spalte) }}</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="zeile-typ">
        <mat-label>Datentyp</mat-label>
        <mat-select [(ngModel)]="spalte.datentyp" (selectionChange)="geaendert()" [disabled]="disabled">
          <mat-option *ngFor="let t of datentypen" [value]="t.wert">
            <mat-icon class="typ-icon">{{ t.icon }}</mat-icon> {{ t.text }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <span class="zeile-pflicht">
        <mat-checkbox [(ngModel)]="spalte.pflicht" (change)="geaendert()"
          [disabled]="disabled || spalte.istKennzeichnung"
          [matTooltip]="spalte.istKennzeichnung ? 'Die Kennzeichnung ist immer ein Pflichtfeld.' : 'Muss beim Anlegen einer Messstelle ausgefüllt werden'">
          <span class="pflicht-text">Pflicht</span>
        </mat-checkbox>
      </span>

      <span class="zeile-kennz">
        <mat-radio-button [checked]="spalte.istKennzeichnung" (change)="kennzeichnungWaehlen(spalte.key)"
          [disabled]="disabled" name="kennzeichnung" [value]="spalte.key"
          matTooltip="Diese Spalte als Kennzeichnung verwenden">
          <span class="kennz-text">{{ spalte.istKennzeichnung ? 'Kennzeichnung' : 'als Kennzeichnung' }}</span>
        </mat-radio-button>
      </span>

      <span class="zeile-aktionen">
        <button mat-icon-button type="button" (click)="verschieben(i, -1)" [disabled]="disabled || i === 0"
          matTooltip="Nach oben" aria-label="Nach oben">
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="verschieben(i, 1)" [disabled]="disabled || i === spalten.length - 1"
          matTooltip="Nach unten" aria-label="Nach unten">
          <mat-icon>arrow_downward</mat-icon>
        </button>
        <button mat-icon-button type="button" color="warn" (click)="spalteEntfernen(i)" [disabled]="disabled"
          [matTooltip]="anzahlWerte(spalte) > 0
            ? 'Spalte entfernen – ' + anzahlWerte(spalte) + ' gespeicherte Werte müssen beim Speichern bestätigt werden'
            : 'Spalte entfernen'"
          aria-label="Spalte entfernen">
          <mat-icon>{{ anzahlWerte(spalte) > 0 ? 'delete_forever' : 'close' }}</mat-icon>
        </button>
      </span>

      <!-- Hinweis auf vorhandene Werte (nur beim Bearbeiten bestehender Listen) -->
      <span class="zeile-werte" *ngIf="anzahlWerte(spalte) > 0">
        <mat-icon inline>info_outline</mat-icon>
        {{ anzahlWerte(spalte) }} Messstelle{{ anzahlWerte(spalte) === 1 ? ' hat' : 'n haben' }} hier Werte
      </span>

    </div>

  </div>

  <!-- Leerzustand -->
  <div class="editor-leer" *ngIf="spalten.length === 0">
    <mat-icon>view_column</mat-icon>
    <p>Noch keine Spalten. Jede Spalte wird zu einem Feld der Messstelle; eine davon ist die Kennzeichnung.</p>
    <button mat-stroked-button type="button" (click)="beispielEinfuegen()" [disabled]="disabled">
      <mat-icon>auto_awesome</mat-icon>
      Beispiel: KKS, Langtext, Medium, Signal
    </button>
  </div>

  <div class="editor-aktionen">
    <button mat-stroked-button color="primary" type="button" (click)="spalteHinzufuegen()" [disabled]="disabled">
      <mat-icon>add</mat-icon>
      Spalte hinzufügen
    </button>

    <span class="editor-anzahl" *ngIf="spalten.length > 0">
      {{ spalten.length }} Spalte{{ spalten.length === 1 ? '' : 'n' }}
    </span>
  </div>

  <!-- Prüfung über die ganze Struktur -->
  <ul class="editor-fehler" *ngIf="fehler.length > 0 && spalten.length > 0">
    <li *ngFor="let f of fehler">
      <mat-icon inline>error_outline</mat-icon> {{ f }}
    </li>
  </ul>

</div>
